import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-view-loader',
  templateUrl: './list-view-loader.component.html',
  styleUrls: ['./list-view-loader.component.css']
})
export class ListViewLoaderComponent implements OnInit {

  @Input() count:number = 1;

  constructor() { }

  ngOnInit(): void {
  }

  loopCounter = () => {
    return [...Array(this.count).keys()]
  }

}
